module.exports = __webpack_public_path__ + "images/a932a422cde6504ec2053963e563ed80.jpg";